module.exports = __webpack_public_path__ + "img/junction-regular.502785a9.svg";